/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
// External imports
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class IndexRoute extends Route {
  // Services
  @service
  store;

  model() {
    return hash({
      schoolGroups: this.store.findAll('schools/group'),
      schools: this.store.findAll('school'),
      tagCategories: this.store.findAll('posts/tag-category'),
      usageSets: this.store.findAll('schools/usage-set'),
    });
  }
}
